import { Milliseconds, ScheduledReportPeriodUnits } from '@iotv/datamodel-core';
export const calculateTimeToNextReport = (nowMS, periodWidth, periodUnit, timeAtFirstReportMS) => {
    const periodMS = periodWidth * periodUnit;
    const timeSinceCreation = nowMS - timeAtFirstReportMS;
    if (timeSinceCreation < 0)
        return timeAtFirstReportMS;
    const timeProgressedThisPeriod = timeSinceCreation % periodMS;
    const timeLeft = periodMS - timeProgressedThisPeriod;
    return nowMS + timeLeft;
};
export const strToPeriodUnits = {
    day: ScheduledReportPeriodUnits.DAY,
    days: ScheduledReportPeriodUnits.DAY,
    hour: ScheduledReportPeriodUnits.HOUR,
    hours: ScheduledReportPeriodUnits.HOUR,
    week: ScheduledReportPeriodUnits.WEEK,
    weeks: ScheduledReportPeriodUnits.WEEK,
};
export const strToMs = {
    day: Milliseconds.DAY,
    days: Milliseconds.DAY,
    hour: Milliseconds.HOUR,
    hours: Milliseconds.HOUR,
    week: Milliseconds.DAY * 7,
    weeks: Milliseconds.DAY * 7,
};
